'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Immutable = require('Immutable');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getInitialCustomFieldState(formFields) {
  return formFields.reduce(function (acc, field) {
    return acc.set(field.name, null);
  }, new _Immutable.Map());
}

var defaults = {
  email: '',
  firstName: '',
  lastName: '',
  customFormFields: new _Immutable.Map()
};

var FormState = function (_Record) {
  _inherits(FormState, _Record);

  function FormState() {
    _classCallCheck(this, FormState);

    return _possibleConstructorReturn(this, (FormState.__proto__ || Object.getPrototypeOf(FormState)).apply(this, arguments));
  }

  _createClass(FormState, null, [{
    key: 'from',
    value: function from(json) {
      json.customFormFields = new _Immutable.Map(json.customFormFields);
      var jsonMap = (0, _Immutable.Map)(json).filter(function (value) {
        return value !== undefined;
      });
      return new FormState(jsonMap);
    }
  }, {
    key: 'customFieldsFromBookInfo',
    value: function customFieldsFromBookInfo(json) {
      var formFields = json.customParams.formFields;
      var customFormFields = getInitialCustomFieldState(formFields);

      return customFormFields;
    }
  }]);

  return FormState;
}((0, _Immutable.Record)(defaults));

exports.default = FormState;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/models/FormState.js
// module id = 34
// module chunks = 0